import { all } from 'redux-saga/effects';
import watchGetUserFavorites from './favorites/GetUserFavorites';
import watchAddFavorites from './favorites/AddFavorites';
import watchDeleteFavorite from './favorites/DeleteFavorites';
import watchGetDashboardList from './dashboard/GetDashboardList';
import watchGetDashboardURL from './dashboard/GetDashboardURL';
import watchGetSageMakerURL from './dashboard/GetSageMakerUrl';
import watchUserOnBoarding from './user/UserOnBoarding';
import watchUserDetails from './user/SaveUserDetails';
import watchGetUserGuide from './userguide/UserGuide';
import watchGetWhatsNew from './whatsnew/WhatsNew';
import watchRequestReportSave from './reports/RequestReport';
import watchGetFaqs from './faqs/Faqs';
import watchGetNotifications from './notification/Notification';

/*
 * ALL your sagas must go into root saga so they can be combined back together.
 * Don't forget to import them before adding them to JSON.
 */
export default function* rootSaga() {
  yield all([
    watchGetUserFavorites(),
    watchAddFavorites(),
    watchDeleteFavorite(),
    watchGetDashboardList(),
    watchGetDashboardURL(),
    watchGetSageMakerURL(),
    watchUserOnBoarding(),
    watchUserDetails(),
    watchGetUserGuide(),
    watchGetWhatsNew(),
    watchRequestReportSave(),
    watchGetFaqs(),
    watchGetNotifications(),
  ]);
}
